import { RenderReactAtSite } from "widgets/commonComponents/inline/renderReactAtSite"
import { SiteArticleSocialShareNew1280 } from "../articleSocialShare1280Component/articleSocialShareNew1280";

interface SiteArticleHeaderShareProps {
    categorySubChannel: string
    author: string
    articleId: string
    showComments: boolean
    isSpotim: boolean
    lang?:string
    title?: string
}

export class SiteArticleHeaderShareWrapper1280 extends React.Component<SiteArticleHeaderShareProps>{

    render() {
        const { categorySubChannel, author, articleId, showComments, isSpotim , lang, title} = this.props
        const Ar =  lang && lang.includes("ar");
        if(Ar) return null;
        else  return (
            <RenderReactAtSite>
                <SiteArticleSocialShareNew1280 categorySubChannel={categorySubChannel}
                    author={author} 
                    articleId={articleId}
                    showComments={showComments}
                    isSpotim={isSpotim}
                    lang={lang}
                    title={title}
                />
            </RenderReactAtSite>
        )
    }
}